import { RHFTextField } from "@components/hook-form";
import { Box, InputAdornment } from "@mui/material";
import { Search } from "lucide-react";
import { IDocumentSeriesFilter } from "../../../../@types/manualDocument/documentSeriesTypes";

export const DocumentSeriesFilter = ({ translate }: IDocumentSeriesFilter) => (
  <Box
    sx={{
      width: "100%",
      mb: 1,
    }}
  >
    <RHFTextField
      name="searchSeries"
      placeholder={translate("search_series")}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      fullWidth
    />
  </Box>
);
